import { Link } from "react-router-dom";

const related = [
  {
    title: "Soft Beige Living Room",
    desc: "How to build a warm, cohesive living room around a soft beige palette.",
    path: "/living-room/soft-beige",
    tag: "Living Room",
    image: "https://public.readdy.ai/ai/img_res/6a7053f59eab291e16feeb6812051666.jpg",
  },
  {
    title: "Small Apartment, Soft Neutrals",
    desc: "Make a compact space feel calm, open, and beautifully considered.",
    path: "/living-room/small-apartment-soft-neutrals",
    tag: "Styling Guide",
    image: "https://readdy.ai/api/search-image?query=small%20apartment%20living%20room%20soft%20neutral%20palette%20cream%20beige%20warm%20ivory%20minimal%20furniture%20natural%20light%20calm%20elegant%20editorial%20interior%20photography&width=640&height=420&seq=cbn_rel2&orientation=landscape",
  },
  {
    title: "Neutral Rugs Guide",
    desc: "The best warm-toned rugs to ground any room in your home.",
    path: "/products/neutral-rugs",
    tag: "Product Guide",
    image: "https://readdy.ai/api/search-image?query=neutral%20area%20rug%20warm%20ivory%20oat%20living%20room%20natural%20light%20calm%20editorial%20interior%20photography%20soft%20texture%20layered%20neutral%20palette&width=640&height=420&seq=cbn_rel3&orientation=landscape",
  },
  {
    title: "Linen Curtains Guide",
    desc: "Soft, airy curtains that filter light and complete a neutral room.",
    path: "/products/linen-curtains",
    tag: "Product Guide",
    image: "https://readdy.ai/api/search-image?query=linen%20curtains%20floor%20to%20ceiling%20soft%20beige%20room%20warm%20natural%20light%20sheer%20fabric%20calm%20elegant%20editorial%20interior%20photography%20neutral%20warm%20palette&width=640&height=420&seq=cbn_rel4&orientation=landscape",
  },
];

export default function CBNRelated() {
  return (
    <section className="py-24 bg-[#FAF7F2]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        <div className="text-center mb-14">
          <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
            Keep Reading
          </p>
          <h2 className="text-[#2C2825] text-3xl md:text-4xl" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
            Related Guides
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {related.map((item) => (
            <Link key={item.title} to={item.path} className="group block cursor-pointer">
              <div className="w-full h-48 rounded-xl overflow-hidden bg-[#EDE6DA] mb-5">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <span
                className="inline-block text-[#B5A898] text-[9px] tracking-[0.2em] uppercase mb-2"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {item.tag}
              </span>
              <h3
                className="text-[#2C2825] text-base mb-2 group-hover:text-[#9E8070] transition-colors"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {item.title}
              </h3>
              <p className="text-[#8B8378] text-xs leading-relaxed" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
                {item.desc}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
